import PropTypes from 'prop-types'
import style from './style.module.scss'
import InnerHTML from '@shared/components/InnerHTML'
import { convertDateAMPM, dateCheck } from '@shared-submodule/utils'
function LiveBlogCard({ data }) {
  return <>
    <div className={`${style.liveBox} ps-3 ps-md-4 position-relative`} id={`${data?._id}_${data?.iEventId}_${data?.sEventId}`}>
      <span className={`${style.date} d-block`}>{convertDateAMPM(dateCheck(new Date(data?.dPublishDate)))} </span>
      <div className={style.details}>
        <h3 className={`${style.title}`}>{data?.sTitle}</h3>
        <InnerHTML className={style.content} html={data?.sContent} />
        <div className='text-capitalize mt-2 mt-md-0'><span className='small-text'>By</span> <span className={`${style.author} small-text font-bold`}>{data?.oAuthor?.sFName}</span> </div>
      </div>
    </div>
  </>
}

LiveBlogCard.propTypes = {
  data: PropTypes.object,
  firstElement: PropTypes.number
}
export default LiveBlogCard
